export const MS_GRAPH_URL = {
  GetUserPhoto: "https://graph.microsoft.com/v1.0/me/photo/$value",
  GetOrganization:
    "https://graph.microsoft.com/v1.0/organization/$1?$select=displayName",
};
